<template>
  <div class="shipper-detail">
    <personal v-if="form.customerType === '个人'" :form="form" />
    <enterprise v-else-if="form.customerType === '企业'" :form="form" />
    <fix-boottom>
      <template slot="button">
        <el-button @click="onReturn">
          返回
        </el-button>
      </template>
    </fix-boottom>
  </div>
</template>

<script>
import FixBoottom from '@/components/FixBoottom/index.vue';
import { getCustomerDetail } from '@/api/shipper';
import Personal from './components/Personal.vue';
import Enterprise from './components/Enterprise.vue';

export default {
  name: 'ShipperDetail',
  components: {
    Personal,
    Enterprise,
    FixBoottom,
  },
  data() {
    return {
      form: {},
    };
  },
  created() {
    const { id } = this.$route.query;
    getCustomerDetail({
      ids: [id],
      needInvoiceBank: true,
    }).then((res) => {
      const data = (res && res[0]) || {};
      this.form = data;
    });
  },
  methods: {
    onReturn() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.shipper-detail {
  padding-bottom: 50px;
}
</style>
